"use client";
import { Text as e } from "../Text/Text.mjs";
import { Check as t, ChevronRight as n } from "../Icon/icons.gen.mjs";
import { DEFAULT_ICON_CLASS_NAME as r } from "../../../utils/iconDefaults.mjs";
import { appendToChildren as i } from "../../../utils/appendToChildren.mjs";
import { forwardRef as a, isValidElement as o } from "react";
import { jsx as s } from "react/jsx-runtime";
import * as c from "@radix-ui/react-dropdown-menu";
//#region src/components/atoms/DropdownMenu/DropdownMenu.tsx
var l = (e) => /* @__PURE__ */ s(c.Root, {
	"data-slot": "dropdown-menu",
	...e
}), u = a((e, t) => /* @__PURE__ */ s(c.Trigger, {
	"data-slot": "dropdown-menu-trigger",
	...e,
	ref: t
}));
u.displayName = "DropdownMenuTrigger";
var d = (e) => /* @__PURE__ */ s(c.Portal, {
	"data-slot": "dropdown-menu-portal",
	...e
}), f = a((e, t) => /* @__PURE__ */ s(d, { children: /* @__PURE__ */ s(c.Content, {
	"data-slot": "dropdown-menu-content",
	...e,
	ref: t
}) }));
f.displayName = "DropdownMenuContent";
var p = a((e, t) => /* @__PURE__ */ s(c.Group, {
	"data-slot": "dropdown-menu-group",
	...e,
	ref: t
}));
p.displayName = "DropdownMenuGroup";
var m = a(({ children: t, fontSize: n = "sm", fontWeight: r = "semibold", fontFamily: i = "inter", ...a }, l) => /* @__PURE__ */ s(c.Label, {
	"data-slot": "dropdown-menu-label",
	...a,
	ref: l,
	children: /* @__PURE__ */ s(e, {
		asChild: !0,
		fontSize: n,
		fontWeight: r,
		fontFamily: i,
		children: o(t) ? t : /* @__PURE__ */ s("span", { children: t })
	})
}));
m.displayName = "DropdownMenuLabel";
var h = a((e, t) => /* @__PURE__ */ s(c.Item, {
	"data-slot": "dropdown-menu-item",
	...e,
	ref: t
}));
h.displayName = "DropdownMenuItem";
var g = a((e, t) => /* @__PURE__ */ s(c.CheckboxItem, {
	"data-slot": "dropdown-menu-checkbox-item",
	...e,
	ref: t
}));
g.displayName = "DropdownMenuCheckboxItem";
var _ = a((e, t) => /* @__PURE__ */ s(c.RadioGroup, {
	"data-slot": "dropdown-menu-radio-group",
	...e,
	ref: t
}));
_.displayName = "DropdownMenuRadioGroup";
var v = a((e, t) => /* @__PURE__ */ s(c.RadioItem, {
	"data-slot": "dropdown-menu-radio-item",
	...e,
	ref: t
}));
v.displayName = "DropdownMenuRadioItem";
var y = a(({ children: e, ...n }, r) => /* @__PURE__ */ s(c.ItemIndicator, {
	"data-slot": "dropdown-menu-item-indicator",
	...n,
	ref: r,
	children: e ?? /* @__PURE__ */ s(t, {
		"data-slot": "dropdown-menu-check-icon",
		"aria-hidden": "true",
		className: "size-4 shrink-0 [&_path]:fill-current"
	})
}));
y.displayName = "DropdownMenuItemIndicator";
var b = a((e, t) => /* @__PURE__ */ s(c.Separator, {
	"data-slot": "dropdown-menu-separator",
	...e,
	ref: t
}));
b.displayName = "DropdownMenuSeparator";
var x = (e) => /* @__PURE__ */ s(c.Sub, {
	"data-slot": "dropdown-menu-sub",
	...e
}), S = a(({ children: e, icon: t = /* @__PURE__ */ s(n, {
	"data-slot": "dropdown-menu-sub-trigger-icon",
	"aria-hidden": "true",
	className: r
}), asChild: a, ...o }, l) => /* @__PURE__ */ s(c.SubTrigger, {
	"data-slot": "dropdown-menu-sub-trigger",
	asChild: a,
	...o,
	ref: l,
	children: i(e, t, a)
}));
S.displayName = "DropdownMenuSubTrigger";
var C = a((e, t) => /* @__PURE__ */ s(d, { children: /* @__PURE__ */ s(c.SubContent, {
	"data-slot": "dropdown-menu-sub-content",
	...e,
	ref: t
}) }));
C.displayName = "DropdownMenuSubContent";
var w = a((e, t) => /* @__PURE__ */ s(c.Arrow, {
	"data-slot": "dropdown-menu-arrow",
	...e,
	ref: t
}));
w.displayName = "DropdownMenuArrow";
//#endregion
export { w as DropdownMenuArrow, g as DropdownMenuCheckboxItem, f as DropdownMenuContent, p as DropdownMenuGroup, h as DropdownMenuItem, y as DropdownMenuItemIndicator, m as DropdownMenuLabel, d as DropdownMenuPortal, _ as DropdownMenuRadioGroup, v as DropdownMenuRadioItem, l as DropdownMenuRoot, b as DropdownMenuSeparator, x as DropdownMenuSub, C as DropdownMenuSubContent, S as DropdownMenuSubTrigger, u as DropdownMenuTrigger };
